import moment from 'moment';

export const dateFormat = 'MM/DD/YYYY hh:mm a';
export const dateFormatWithoutTime = 'MM/DD/YYYY';
// user expiration date format
export const expirationInputFormat = 'YYYY-MM-DD';
export const expirationFormat = 'YYYY/MM/DD';
export const dayFirstFormat = 'DD/MM/YYYY';
export const minExpirationDate = moment().add(1, 'day').format(expirationInputFormat);
export const maxExpirationDate = moment().add(1, 'year').format(expirationInputFormat);

export const renderDate = date =>
  moment(date).utc().local().format(dateFormat);

export const renderDateWithFormat = (date, format) =>
  moment(date).utc().format(format || expirationFormat);

export const formatExpirationInputDate = date => moment.utc(date).format(expirationInputFormat);
export const formatExpirationDate = date => moment.utc(date).format(expirationFormat);

export const isSameOrAfterToday = date => moment(date).isSameOrAfter(new Date(), 'day');

export const twoWeeksBeforeDate = date => moment(date).subtract(2, 'weeks').toISOString();

export const isBetweenDates = (initialDate, finalDate, date = new Date()) =>
  moment(date).isBetween(initialDate, finalDate);
